import type { i18n as I18n } from 'i18next';
import { writeLangCookie } from './langCookie';
import { vendorApiClient } from './vendorApiClient';

export const LANGUAGE_SENT_KEY = 'glp-vendor-language-sent';

export type PortalLanguage = 'en' | 'es';

export function currentLanguage(i18n: Pick<I18n, 'language'>): PortalLanguage {
  return i18n.language?.startsWith('es') ? 'es' : 'en';
}

/** Switches the portal now and records the choice on the account, so emails to this person follow it. */
export function switchPortalLanguage(i18n: Pick<I18n, 'changeLanguage'>, lang: string, signedIn: boolean): void {
  if (lang !== 'en' && lang !== 'es') return;
  void i18n.changeLanguage(lang);
  writeLangCookie(lang);
  if (!signedIn) return;
  try {
    window.sessionStorage.setItem(LANGUAGE_SENT_KEY, lang);
  } catch {
    // No session storage: the shell sends it again, which is harmless.
  }
  vendorApiClient.setLanguage(lang).catch(() => undefined);
}
